var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalkonAiWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.149,
    height: 24,
    viewBox: "0 0 24.149 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161280",
    "data-name": "Group 161280",
    transform: "translate(-0.351)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1949",
    "data-name": "Rectangle 1949",
    width: 24,
    height: 24,
    transform: "translate(0.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160760",
    "data-name": "Group 160760",
    transform: "translate(0.951 3.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M9.107,6.177a13.557,13.557,0,0,1-7.1,7.094.552.552,0,0,0,0,1.014,13.526,13.526,0,0,1,7.076,7.039.581.581,0,0,0,1.068,0,13.551,13.551,0,0,1,7.075-7.039.551.551,0,0,0,0-1.013,13.559,13.559,0,0,1-7.1-7.1.556.556,0,0,0-1.022,0Z",
    transform: "translate(-1.672 -5.639)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M131.5,111.356a4.96,4.96,0,0,1-2.249,2.249.329.329,0,0,0,0,.592,4.95,4.95,0,0,1,2.249,2.249.328.328,0,0,0,.591,0,4.96,4.96,0,0,1,2.25-2.25.329.329,0,0,0,0-.591,4.957,4.957,0,0,1-2.249-2.25.329.329,0,0,0-.592,0Z",
    transform: "translate(-115.058 -99.383)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M145.049,4.307a6.809,6.809,0,0,1-2.855,2.855.548.548,0,0,0,0,.967,6.785,6.785,0,0,1,2.854,2.854.549.549,0,0,0,.968,0,6.8,6.8,0,0,1,2.854-2.854.548.548,0,0,0,0-.967,6.822,6.822,0,0,1-2.855-2.855.548.548,0,0,0-.967,0Z",
    transform: "translate(-126.48 -4.018)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonAiWhiteIcon);
export default __webpack_public_path__ + "static/media/falkon-ai-white-icon.ad8d82dfeca5fdfe9408411070c3908a.svg";
export { ForwardRef as ReactComponent };